import { useState, useEffect } from 'react';
import { getJobs } from '../utils/api';
import Attachments from '../components/Attachments';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

export default function AttachmentsPortal() {
  const { signOut, username } = useAuth();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [loading, setLoading] = useState(false);
  const [listMode, setListMode] = useState(false);
  const [allJobs, setAllJobs] = useState([]);
  const [allLoading, setAllLoading] = useState(false);

  async function handleSearch(e) {
    e.preventDefault();
    if (!search.trim()) return;
    setLoading(true);
    setSelectedJob(null);
    try {
      const data = await getJobs({ search: search.trim() });
      const results = Array.isArray(data) ? data : data.jobs || [];
      if (results.length === 1) {
        setSelectedJob(results[0]);
      } else if (results.length === 0) {
        toast.error('No job found');
      } else {
        setJobs(results);
      }
    } catch {
      toast.error('Search failed');
    } finally {
      setLoading(false);
    }
  }

  async function loadAllJobs() {
    setAllLoading(true);
    try {
      const data = await getJobs({ limit: 500 });
      const results = Array.isArray(data) ? data : data.jobs || [];
      setAllJobs(results);
      setListMode(true);
    } catch {
      toast.error('Failed to load jobs');
    } finally {
      setAllLoading(false);
    }
  }

  function handleLogout() {
    signOut();
    navigate('/login');
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', fontFamily: 'DM Sans, sans-serif' }}>
      {/* Header */}
      <div style={{ background: '#0D3B2E', color: '#fff', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <span style={{ fontFamily: 'DM Serif Display, serif', fontSize: 22, color: '#F57F17' }}>CPR</span>
          <span style={{ marginLeft: 8, fontSize: 14, color: '#ccc' }}>Attachments Portal</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ fontSize: 13, color: '#ccc' }}>{username}</span>
          <button onClick={handleLogout} style={{ background: 'none', border: '1px solid #ccc', color: '#ccc', borderRadius: 6, padding: '4px 12px', cursor: 'pointer', fontSize: 13 }}>
            Sign out
          </button>
        </div>
      </div>

      <div style={{ maxWidth: 800, margin: '40px auto', padding: '0 24px' }}>
        {/* Search */}
        <div style={{ background: '#fff', borderRadius: 10, padding: 24, marginBottom: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
          <h2 style={{ margin: '0 0 16px', color: '#0D3B2E', fontSize: 18 }}>Upload Attachments</h2>
          <form onSubmit={handleSearch} style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search by PO# or customer name..."
              style={{ flex: 1, border: '1px solid #ccc', borderRadius: 6, padding: '8px 12px', fontSize: 14, outline: 'none' }}
            />
            <button type="submit" disabled={loading} style={{ background: '#1B5E20', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
              {loading ? 'Searching…' : 'Search'}
            </button>
          </form>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ flex: 1, height: 1, background: '#eee' }} />
            <span style={{ color: '#aaa', fontSize: 12 }}>or</span>
            <div style={{ flex: 1, height: 1, background: '#eee' }} />
          </div>
          <button onClick={loadAllJobs} disabled={allLoading} style={{ marginTop: 12, width: '100%', background: '#f5f5f5', border: '1px solid #ddd', borderRadius: 6, padding: '8px', cursor: 'pointer', fontSize: 14, color: '#333' }}>
            {allLoading ? 'Loading…' : 'Browse All Jobs'}
          </button>
        </div>

        {/* Search results list */}
        {jobs.length > 1 && !selectedJob && (
          <div style={{ background: '#fff', borderRadius: 10, padding: 16, marginBottom: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
            <div style={{ fontSize: 13, color: '#555', marginBottom: 10 }}>Multiple results — select a job:</div>
            {jobs.map(j => (
              <div key={j.id} onClick={() => setSelectedJob(j)} style={{ padding: '10px 12px', borderRadius: 6, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f0f0f0' }}
                onMouseEnter={e => e.currentTarget.style.background = '#f5f5f5'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                <span style={{ fontWeight: 600, color: '#0D3B2E' }}>{j.po_number}</span>
                <span style={{ color: '#555' }}>{j.customer_name}</span>
              </div>
            ))}
          </div>
        )}

        {/* All jobs list */}
        {listMode && !selectedJob && (
          <div style={{ background: '#fff', borderRadius: 10, padding: 16, marginBottom: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
              <div style={{ fontSize: 13, color: '#555' }}>{allJobs.length} jobs — click to upload attachments</div>
              <button onClick={() => setListMode(false)} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: 12 }}>✕ Close</button>
            </div>
            <div style={{ maxHeight: 400, overflowY: 'auto' }}>
              {allJobs.map(j => (
                <div key={j.id} onClick={() => { setSelectedJob(j); setListMode(false); }}
                  style={{ padding: '10px 12px', borderRadius: 6, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f0f0f0' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f5f5f5'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <span style={{ fontWeight: 600, color: '#0D3B2E', minWidth: 100 }}>{j.po_number}</span>
                  <span style={{ flex: 1, color: '#333', marginLeft: 12 }}>{j.customer_name}</span>
                  <span style={{ color: '#888', fontSize: 12 }}>{j.sales_rep}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Selected job attachments */}
        {selectedJob && (
          <div style={{ background: '#fff', borderRadius: 10, padding: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 16, color: '#0D3B2E' }}>{selectedJob.po_number}</div>
                <div style={{ color: '#555', fontSize: 14 }}>{selectedJob.customer_name}</div>
                {selectedJob.address && <div style={{ color: '#888', fontSize: 13 }}>{selectedJob.address}</div>}
              </div>
              <button onClick={() => { setSelectedJob(null); setJobs([]); setSearch(''); }}
                style={{ background: 'none', border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px', cursor: 'pointer', fontSize: 13, color: '#555' }}>
                ← Back
              </button>
            </div>
            <Attachments jobId={selectedJob.id} />
          </div>
        )}
      </div>
    </div>
  );
}
